import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { saveReferralToCookie } from '../utils/cookieUtils';

const ReferralHandler = () => {
    const location = useLocation();

    useEffect(() => {
        try {
            const queryParams = new URLSearchParams(location.search);
            const ref = queryParams.get('ref');

            if (ref) {
                saveReferralToCookie(ref);
            }
        } catch (error) {
            console.error('Error handling referral:', error);
        }
    }, [location]);

    return null; // This component does not render anything
};

export default ReferralHandler;